import './hero.component.scss'
import './hero.component.pug'

import { Swiper, Autoplay, Pagination, Mousewheel } from 'swiper'

Swiper.use([Autoplay, Pagination, Mousewheel])

async function videoWatcher(swiperElement, activeIndex, oldIndex) {
  const activeSlide = swiperElement.querySelectorAll('.swiper-slide')[
    activeIndex
  ]
  let oldSlide
  if (oldIndex) {
    oldSlide = swiperElement.querySelectorAll('.swiper-slide')[oldIndex]
  }
  if (activeSlide) {
    const video = activeSlide.querySelector('video')
    if (video) {
      await video.play()
    }
  }
  if (oldSlide) {
    const video = oldSlide.querySelector('video')
    if (video) {
      await video.pause()
    }
  }
}

document
  .querySelectorAll('.hero .swiper-container')
  .forEach((swiperElement) => {
    let memoryIndex = 0
    const swiper = new Swiper(swiperElement, {
      speed: 800,
      autoplay: {
        delay: 5000,
        disableOnInteraction: true
      },
      mousewheel: {
        forceToAxis: true
      },
      pagination: {
        el: swiperElement.querySelector('.swiper-pagination'),
        type: 'bullets',
        clickable: true
      }
    })
    swiper.autoplay.stop()

    swiper.on('slideChange', () => {
      videoWatcher(swiperElement, swiper.activeIndex, memoryIndex)
      memoryIndex = swiper.activeIndex
    })

    import(
      /* webpackChunkName: "interactiveFabric" */ '../../application/interactiveFabric'
    ).then(({ ScrollMagic }) => {
      const controller = new ScrollMagic.Controller()
      const scene = new ScrollMagic.Scene({
        duration: '100%',
        offset: 0,
        triggerElement: swiperElement
      }).addTo(controller)
      if (process.env.NODE_ENV === 'production') {
        swiper.autoplay.start()
      }
      scene.on('enter', async function () {
        if (process.env.NODE_ENV === 'production') {
          const video = swiperElement.querySelector(
            '.swiper-slide-active video'
          )
          if (video) {
            await video.play()
          }
        }
      })
      scene.on('leave', async function () {
        swiper.autoplay.stop()
        const video = swiperElement.querySelector('.swiper-slide-active video')
        if (video) {
          await video.pause()
        }
      })
    })
  })
